import { type Position } from '../types'

type PathPoints = {
  sourceX: number
  sourceY: number
  targetX: number
  targetY: number
  startPosition: Position
  endPosition: Position
}

const CONTROL_POINT_OFFSET = 50

export const generatePathData = (points: PathPoints, lineShape: 'curve' | 'square'): string => {
  if (lineShape === 'square') return generateSquarePath(points)
  return generateCurvePath(points)
}

const generateSquarePath = (points: PathPoints): string => {
  const { sourceX, sourceY, targetX, targetY, startPosition } = points
  const midX = (sourceX + targetX) / 2
  const midY = (sourceY + targetY) / 2

  if (startPosition === 'left' || startPosition === 'right')
    return `M ${sourceX} ${sourceY} L ${midX} ${sourceY} L ${midX} ${targetY} L ${targetX} ${targetY}`

  return `M ${sourceX} ${sourceY} L ${sourceX} ${midY} L ${targetX} ${midY} L ${targetX} ${targetY}`
}

const generateCurvePath = (points: PathPoints): string => {
  const { sourceX, sourceY, targetX, targetY, startPosition, endPosition } = points

  const startControlPoint = calculateControlPointForPosition(sourceX, sourceY, startPosition)
  const endControlPoint = calculateControlPointForPosition(targetX, targetY, endPosition)

  return `M ${sourceX} ${sourceY} C ${startControlPoint.x} ${startControlPoint.y}, ${endControlPoint.x} ${endControlPoint.y}, ${targetX} ${targetY}`
}

const calculateControlPointForPosition = (x: number, y: number, position: Position): { x: number; y: number } => {
  if (position === 'left') {
    return { x: x - CONTROL_POINT_OFFSET, y }
  }
  if (position === 'right') {
    return { x: x + CONTROL_POINT_OFFSET, y }
  }
  if (position === 'top') {
    return { x, y: y - CONTROL_POINT_OFFSET }
  }
  return { x, y: y + CONTROL_POINT_OFFSET }
}
